import { useQuery } from "@tanstack/react-query"
import { LIST_OBJECTIVES_KEY } from "../../constants"
import { useAxios } from "../../contexts/AxiosContext"
import useWorkspace from "../../components/hooks/workspace/useWorkspace"

export type Objective = {
  id: number
  description: string
  heading: string
  label: string
  movement: "increase" | "decrease"
  objective: string
  type: number
}

export type UseObjectivesType = {
  objectives: Objective[]
  isLoading: boolean
  error: Error | null
}

const useObjectives = (): UseObjectivesType => {

  const { axiosApiInstance } = useAxios()
  const { workspace } = useWorkspace()
  const workspaceId = workspace?.id ?? ""
  const subscriptionSellingEnabled = workspace?.subscription_selling_enabled === true

  const { data: objectives, isLoading, error } = useQuery({
    queryKey: [LIST_OBJECTIVES_KEY, workspaceId, subscriptionSellingEnabled],
    queryFn: async (): Promise<Objective[]> => {
      const response = await axiosApiInstance.get<Objective[]>('/experiment/objectives', {
        params: {
          workspace_id: workspaceId,
        },
      })
      return response.data
    },
    select: (data) => {
      return data.map(objective => ({ ...objective, id: Number(objective.id || 0) }))
    },
    enabled: Boolean(workspaceId),
  })

  return { objectives: objectives ?? [], isLoading, error }
}

export default useObjectives
